module.exports = {
	lang: 'bg',
	backend: 'http://www.homeschoolingbg.com/api'
};



// WEBPACK FOOTER //
// ./src/cfg/app_config.js